// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"00e7f1b4","769":"81978c86"}[chunkId] + ".chunk.js";
};